export const FirebaseInsurancesKey = "insurances";
export const FirebaseBalanceRequestsKey = "balance-requests";
export const NotificationsFirebaseKey = "notifications";
export const SeenNotificationsFirebaseKey = "seen-notifications";
export const FirebaseRequestsKey = "requests";
export const FirebaseNotificationsBySectionKey = "notifications-by-section";
export const FirebaseInternalChatMessagesKey = "internal-chat";
